import { render, staticRenderFns } from "./MerchantCC.vue?vue&type=template&id=19db2b5a&scoped=true&"
import script from "./MerchantCC.vue?vue&type=script&lang=js&"
export * from "./MerchantCC.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19db2b5a",
  null
  
)

export default component.exports